import React from 'react';
import { PortfolioCompanyContext, PortfolioCompanyContextData } from 'src/providers';

export const usePortfolioCompany = (): PortfolioCompanyContextData => {
  return React.useContext<PortfolioCompanyContextData>(PortfolioCompanyContext);
};
